<template>
    <div class="bg-white p-3">
            <PageHeaderUI
            back=""
            title="Cards"
            breadcrumb="Settings > Cards"
          />

          <div>
            <Cards/>
          </div>
    </div>
</template>

<script>
  import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
  import Cards from "@/components/Ondemand/Settings/Cards.vue";

    export default {
        components: { PageHeaderUI, Cards }
    }
</script>

<style lang="scss" scoped>

</style>